const STATUS_I18N_SEGMENT: Readonly<Record<string, string>> = {
  lobby: 'waiting',
}

export function statusI18nSegment(status: string): string {
  return STATUS_I18N_SEGMENT[status] ?? status
}
